module.exports = __webpack_public_path__ + "1eacf9335046ebcbfccc4036a7f9c7cb.svg";